import "../../index41.css";
import { jsxs as N, jsx as V } from "react/jsx-runtime";
import { useLayoutEffect as A, useRef as D } from "react";
import { _ as m } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import z from "../../hooks/useSpacingToken.js";
import { getSpacingValue as j, fullSpacings as E, gapSpacings as $ } from "../../utils/style.js";
const T = "_list-view_1q8ux_1", H = "_with-overflow_1q8ux_5", I = "_with-grow_1q8ux_9", J = "_grid-layout_1q8ux_13", K = "_grid-content_1q8ux_20", M = "_grid-content-with-sidebar_1q8ux_24", Q = "_xs-sidebar_1q8ux_38", U = "_sm-sidebar_1q8ux_42", X = "_md-sidebar_1q8ux_46", Y = "_lg-sidebar_1q8ux_50", Z = "_sidebar-position-start_1q8ux_57", tt = "_with-sidebar_1q8ux_70", it = "_inline-layout_1q8ux_75", et = "_with-wrap_1q8ux_80", nt = "_with-space-between-contents_1q8ux_85", rt = "_with-centered-contents_1q8ux_89", ot = "_with-start-alignment_1q8ux_93", st = "_block-layout_1q8ux_98", at = "_with-full-width_1q8ux_107", dt = "_with-background_1q8ux_111", ct = "_with-dark-background_1q8ux_116", t = {
  listView: T,
  withOverflow: H,
  withGrow: I,
  gridLayout: J,
  gridContent: K,
  gridContentWithSidebar: M,
  xsSidebar: Q,
  smSidebar: U,
  mdSidebar: X,
  lgSidebar: Y,
  sidebarPositionStart: Z,
  withSidebar: tt,
  inlineLayout: it,
  withWrap: et,
  withSpaceBetweenContents: nt,
  withCenteredContents: rt,
  withStartAlignment: ot,
  blockLayout: st,
  withFullWidth: at,
  withBackground: dt,
  withDarkBackground: ct
};
function lt(e) {
  const o = D(null);
  return e && typeof e != "function" ? e : o;
}
function pt(e) {
  const {
    className: o,
    layout: i = "inline",
    withWrap: b,
    withSpaceBetweenContents: p,
    withCenteredContents: S,
    withStartAlignment: f,
    spacing: s,
    withPadding: a,
    withBackground: x,
    withDarkBackground: C,
    children: c,
    numPreferredGridColumns: d = 2,
    minGridColumnSize: l = "12rem",
    gridContentClassName: k,
    withSidebar: w,
    sidebarPosition: y = "end",
    sidebarSize: r = "md",
    spacingOffset: q,
    withFullWidth: P,
    elementRef: B,
    withSpacingOpticalCorrection: v = !1,
    withOverflow: L = !1,
    withGrow: W = !1,
    ...O
  } = e, n = lt(B);
  A(() => {
    var _, h, g;
    if (i === "grid") {
      (_ = n.current) == null || _.style.setProperty(
        "--num-preferred-grid-columns",
        String(d)
      ), (h = n.current) == null || h.style.setProperty(
        "--min-grid-column-size",
        String(l)
      );
      const F = a ? 2 : 0, G = d - 1, R = F + G;
      (g = n.current) == null || g.style.setProperty(
        "--reserved-space",
        `calc(${j(s)} * ${R})`
      );
    }
  }, [d, l, i, a, s, n]);
  const u = z({
    spacing: s,
    offset: q,
    modes: a ? E : $,
    withoutOpticalCorrection: !v
  });
  return /* @__PURE__ */ N(
    "div",
    {
      ...O,
      ref: n,
      className: m(
        t.listView,
        i === "inline" && t.inlineLayout,
        i === "block" && t.blockLayout,
        i === "grid" && t.gridLayout,
        i !== "grid" && u,
        b && t.withWrap,
        f && t.withStartAlignment,
        p && t.withSpaceBetweenContents,
        S && t.withCenteredContents,
        P && t.withFullWidth,
        x && t.withBackground,
        C && t.withDarkBackground,
        w && t.withSidebar,
        L && t.withOverflow,
        W && t.withGrow,
        o
      ),
      role: i !== "grid" ? "list" : void 0,
      children: [
        i === "grid" && /* @__PURE__ */ V(
          "div",
          {
            className: m(
              t.gridContent,
              u,
              k,
              w && t.gridContentWithSidebar,
              y === "start" && t.sidebarPositionStart,
              r === "xs" && t.xsSidebar,
              r === "sm" && t.smSidebar,
              r === "md" && t.mdSidebar,
              r === "lg" && t.lgSidebar
            ),
            role: "grid",
            children: c
          }
        ),
        i !== "grid" && c
      ]
    }
  );
}
export {
  pt as default
};
